// ═══════════════════════════════════════════════════════════════════════════════
// ui--manifesto--confetti-v3
// ───────────────────────────────────────────────────────────────────────────────
// Wraps canvas-confetti для celebratory effects (CTA click, success states).
// Параметры через data-attributes:
//   data-ui--manifesto--confetti-v3-mode-value    = "side" | "burst" | "rain"
//   data-ui--manifesto--confetti-v3-colors-value  = JSON array (опц.)
// ═══════════════════════════════════════════════════════════════════════════════

import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  static values = {
    mode:    { type: String, default: "side" },
    colors:  { type: Array,  default: ["#7c3aed", "#ec4899", "#f59e0b", "#10b981", "#06b6d4"] },
    duration:{ type: Number, default: 1200 },
  }

  fire(e) {
    e?.preventDefault?.()
    const colors = this.colorsValue

    if (this.modeValue === "burst") {
      confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 }, colors })
      return
    }

    if (this.modeValue === "rain") {
      const end = Date.now() + this.durationValue * 2
      const tick = () => {
        confetti({ particleCount: 4, angle: 90, spread: 360, origin: { x: Math.random(), y: -0.1 }, gravity: 0.8, scalar: 0.9, colors })
        if (Date.now() < end) requestAnimationFrame(tick)
      }
      tick()
      return
    }

    // side (default) — двусторонний поток + центральный burst
    const end = Date.now() + this.durationValue
    const tick = () => {
      confetti({ particleCount: 5, angle: 60,  spread: 55, origin: { x: 0, y: 0.7 }, colors })
      confetti({ particleCount: 5, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors })
      if (Date.now() < end) requestAnimationFrame(tick)
    }
    tick()
    confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 }, colors })
  }
}
